import { render, staticRenderFns } from "./Authorized.vue?vue&type=template&id=2c7c502a&scoped=true&"
import script from "./Authorized.vue?vue&type=script&lang=ts&"
export * from "./Authorized.vue?vue&type=script&lang=ts&"
import style0 from "./Authorized.vue?vue&type=style&index=0&id=2c7c502a&scoped=true&lang=scss&"
import style1 from "./Authorized.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7c502a",
  null
  
)

export default component.exports